import React, {FC, useMemo} from 'react';
import {ForecastDaysMode} from '@/app/constants/forecast';
import {WeatherForecastDay, WeatherForecastLocation} from '@/app/interfaces/weather';
import {WeatherDailyTabs} from '../WeatherDailyTabs';
import {WeatherDailyDetails} from '../WeatherDailyDetails';

type LocalDayMode = ForecastDaysMode.Days7 | ForecastDaysMode.Days10;

const daysCountPerMode: Record<LocalDayMode, number> = {
	[ForecastDaysMode.Days7]: 7,
	[ForecastDaysMode.Days10]: 10,
};

interface WeatherDailyProps {
	location: WeatherForecastLocation;
	daysMode: LocalDayMode;
	days: WeatherForecastDay[];
	selectedDay: number;
}

export const WeatherDaily: FC<WeatherDailyProps> = props => {
	const {location, daysMode, days, selectedDay} = props;

	const daysCount = daysCountPerMode[daysMode];

	const dayBriefs = useMemo(() => {
		return days
			.map(day => ({
				date: day.date,
				isHoliday: day.isHoliday,
				temperature: day.temperature,
				condition: day.condition,
				isToday: !!day.now,
			}))
			.slice(0, daysCount);
	}, [days, daysCount]);

	const detailedDay = days[selectedDay];
	const detailedDayIsPast = !detailedDay.now && days.findIndex(day => !!day.now) > selectedDay;

	return (
		<>
			<WeatherDailyTabs location={location} daysMode={daysMode} days={dayBriefs} selectedDay={selectedDay} />
			<WeatherDailyDetails
				location={location}
				day={detailedDay}
				dayIsPast={detailedDayIsPast}
				showBanner={daysMode === ForecastDaysMode.Days10}
			/>
		</>
	);
};

WeatherDaily.displayName = 'WeatherDaily';
